import { createContext } from "react";
import Map from "ol/Map";

const MapContext = createContext<{ map: Map | null }>({ map: null });

export default MapContext;
export { MapContext };
